"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getChallengesMock = {
    content_games: [
        {
            id: 13,
            title: 'Advanced Challenge for Java',
            author: null,
            language: 'java',
            level: 'Intermediate',
            challenges_query: 'tags=java_auto-generated',
            enabled: true,
            created_at: '2020-05-07T12:52:36.000Z',
            updated_at: '2022-12-05T02:00:17.000Z',
            checked_out_user: '',
            name: 'advanced_java',
            number_of_questions: 10,
            active_on_free: true,
            weekly_challenge: false,
            language_display_name: 'Java',
        },
        {
            id: 14,
            title: 'Advanced Challenge for Javascript',
            author: null,
            language: 'javascript',
            level: 'Intermediate',
            challenges_query: 'tags=javascript_auto-generated',
            enabled: true,
            created_at: '2020-05-07T12:53:19.000Z',
            updated_at: '2022-12-05T02:00:17.000Z',
            checked_out_user: '',
            name: 'advanced_javascript',
            number_of_questions: 10,
            active_on_free: true,
            weekly_challenge: true,
            language_display_name: 'JavaScript',
        },
        {
            id: 16,
            title: 'Advanced Challenge for C/C++',
            author: null,
            language: 'cplus',
            level: 'Intermediate',
            challenges_query: 'tags=cplus_auto-generated',
            enabled: true,
            created_at: '2020-05-07T12:54:35.000Z',
            updated_at: '2022-11-21T02:00:38.000Z',
            checked_out_user: '',
            name: 'advanced_cplus',
            number_of_questions: 10,
            active_on_free: true,
            weekly_challenge: false,
            language_display_name: 'C/C++',
        },
        {
            id: 17,
            title: 'Advanced Challenge for .NET',
            author: null,
            language: 'dotnet',
            level: 'Intermediate',
            challenges_query: 'tags=csharp_auto-generated',
            enabled: true,
            created_at: '2020-05-07T12:56:40.000Z',
            updated_at: '2022-11-28T02:00:28.000Z',
            checked_out_user: '',
            name: 'advanced_dotnet',
            number_of_questions: 10,
            active_on_free: true,
            weekly_challenge: false,
            language_display_name: '.NET',
        },
    ],
    weekly_challenge_data: { highest_score: 9853, total_players: 1 },
};
exports.default = getChallengesMock;
